import React, { useCallback } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventLabel from '../../components/EventLabel/EventLabel';
import ReceiptIcon from '@material-ui/icons/Receipt';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import _ from 'lodash';
import { PaymentMethod } from './types';

interface PaymentMethodButtonProps {
  option: PaymentMethod;
  onSelectOption: (options: PaymentMethod) => void;
  selectedOption: PaymentMethod | null;
}

const labels = {
  invoice: 'InvoicePayment',
  stripe: null,
  dibs: 'CardPayment',
};

const icons = {
  invoice: <i className="ri-file-list-2-line ri-md" />,
  stripe: (
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/1280px-Stripe_Logo%2C_revised_2016.svg.png"
      style={{ width: '50px' }}
      alt="Stripe"
    />
  ),
  dibs: <i className="ri-bank-card-line ri-md" />,
};

export default function PaymentMethodButton({ option, onSelectOption, selectedOption }: PaymentMethodButtonProps) {
  const handleSelect = useCallback(() => {
    onSelectOption(option);
  }, [option, onSelectOption]);

  // if (!labels[option]) return <EventLabel name={'NoPayment'} groupName={'CMS.Payment'} />;

  return (
    <button
      disabled={selectedOption === option}
      onClick={handleSelect}
      className={'w-full py-2 px-3 bg-transparent flex items-center gap-x-2' + (selectedOption === option ? ' active' : '')}
    >
      {selectedOption === option ? (
        <i className="ri-checkbox-circle-fill ri-md text-[teal] top-1 right-2" />
      ) : (
        <i className="ri-checkbox-blank-circle-line ri-md  text-neutral-400 top-1 right-2" />
      )}
      {icons[option]}
      {labels[option] && (
        <div className="text-center flex justify-center">
          <EventLabel name={labels[option]} groupName={'CMS.Payment'} />
        </div>
      )}
    </button>
  );
}
